var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 6L6 18","stroke":"#63656C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6 6L18 18","stroke":"#63656C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Cross.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
